"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var InputSizesCSS_1 = require("./InputSizesCSS");

var InputStatesCSS_1 = require("./InputStatesCSS");

var theme_1 = require("../theme");

exports.Select = styled_components_1.default.select(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  outline: none;\n  padding: 0.8em 1em;\n  font-size: 0.9em;\n  border: 1px solid ", ";\n  border-bottom: 2px solid ", ";\n  appearance: none;\n  border-radius: 4px;\n  background: ", ";\n  &::placeholder {\n    color: ", ";\n  }\n  background-image: linear-gradient(45deg, transparent 50%, ", " 50%),\n    linear-gradient(135deg, ", " 50%, transparent 50%),\n    linear-gradient(to right, ", ", ", ");\n  background-position: calc(100% - 20px) calc(1.25em), calc(100% - 15px) calc(1.25em), calc(100% - 2.5em) 0.5em;\n  background-size: 5px 5px, 5px 5px, 1px 2em;\n  background-repeat: no-repeat;\n  ", "\n  ", "\n"])), function (props) {
  return props.width || "100%";
}, theme_1.theme.colors.white[500], theme_1.theme.colors.white[300], theme_1.theme.colors.white[900], theme_1.theme.colors.gray[900], theme_1.theme.colors.white[300], theme_1.theme.colors.white[300], theme_1.theme.colors.white[300], theme_1.theme.colors.white[300], InputStatesCSS_1.InputStatesCSS, InputSizesCSS_1.InputSizesCSS);